import React from "react";
import { ClipboardCheckIcon, GitForkIcon, BarChart3Icon, FileTextIcon, ArrowDownIcon, ArrowRightIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { learningResources, caseMatrixSteps } from "../../data/volumes";
const icons = [ClipboardCheckIcon, GitForkIcon, BarChart3Icon, FileTextIcon];
export function ResourcesSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-342" data-mp="1f7cyuxqog0ug">
      <div className="mx-auto max-w-5xl" data-id="element-343" data-mp="1f8xvcswjxtuy">
        <p className="text-center font-serif text-3xl font-black text-wine sm:text-4xl" data-id="element-344" data-mp="1j8ya6enkc72j">And That’s Not All.</p>
        <h2 className="mt-3 text-center font-serif text-[26px] font-bold leading-tight text-navy sm:text-3xl" data-id="element-345" data-mp="1o7j8g8j98goc">
          You’ll Also Have Access to Practical Clinical Learning Resources
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-muted" data-id="element-346" data-mp="vjx613lrji32">
          The collection is designed to support more than passive reading — with educational tools that help
          you organize and revisit important clinical concepts.
        </p>

        <ul className="mt-10 grid gap-x-10 gap-y-6 sm:grid-cols-2" data-id="element-347" data-mp="1ici2j3etiw3q">
          {learningResources.map((r, i) => {
          const Icon = icons[i];
          return <li key={r.title} className="flex gap-4" data-id="element-348" data-mp="19giwlmb3gms1" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy text-gold" data-id="element-349" data-mp="14j91pr4xriwt">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-350" data-mp="zk62inbn06wr" />
                </span>
                <div data-id="element-351" data-mp="ukbcelzorlcr">
                  <h3 className="text-lg font-extrabold uppercase tracking-wide text-navy" data-id="element-352" data-mp="ujrxzf98vf3h">{r.title}</h3>
                  <p className="mt-1 text-muted" data-id="element-353" data-mp="qk0y8m1qpomt">{r.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-12 rounded-3xl bg-navy p-6 sm:p-8" data-id="element-354" data-mp="lmhkrocv9fvx">
          <h3 className="text-center text-lg font-extrabold uppercase tracking-wide text-gold" data-id="element-355" data-mp="2kvxpof06muhv">Case Review Matrices</h3>
          <p className="mt-2 text-center text-white/80" data-id="element-356" data-mp="2fw31ij7skj0i">Visual frameworks connecting:</p>
          <ol className="mt-6 flex flex-col items-stretch gap-2 lg:flex-row lg:items-center" data-id="element-357" data-mp="2z1hmjy7g4doh">
            {caseMatrixSteps.map((s, i) => <React.Fragment key={s} data-id="element-358" data-mp="2q2cnmqrz2ibs" data-mpi={i}>
                <li className="rounded-xl bg-white px-4 py-3 text-center text-[15px] font-bold text-navy lg:flex-1" data-id="element-359" data-mp="2q3dz2wcwh6u1">
                  {s}
                </li>
                {i < caseMatrixSteps.length - 1 && <li aria-hidden="true" className="flex justify-center" data-id="element-360" data-mp="3irjm5prff7x1">
                    <ArrowDownIcon className="h-5 w-5 text-gold lg:hidden" data-id="element-361" data-mp="3mrbz0enus087" />
                    <ArrowRightIcon className="hidden h-5 w-5 text-gold lg:block" data-id="element-362" data-mp="38t3vfnwba0o2" />
                  </li>}
              </React.Fragment>)}
          </ol>
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center text-sm text-muted" data-id="element-363" data-mp="1xcvzw6farplw">
          These tools are intended to support professional education and structured reasoning. They are not
          automatic diagnostic or treatment-prescription systems.
        </p>

        <SectionCta label="Yes! I want the complete blueprint" data-id="element-364" data-mp="1uv3p221sz1a9" />
      </div>
    </section>;
}